'use client';
// src/components/SyncClientData.tsx
// Syncs localStorage cart/wishlist to DB when user is logged in
// NOTE: session cookie is httpOnly — not visible via document.cookie.
// We always attempt sync; API returns {ok:false} if not authenticated.
import { useEffect } from "react";

export function SyncClientData() {
  useEffect(() => {
    const lastSync = sessionStorage.getItem("data_synced_at");
    const now = Date.now();
    if (lastSync && now - Number(lastSync) < 5 * 60 * 1000) return; // 5 min cooldown

    try {
      const cart = JSON.parse(localStorage.getItem("cart") ?? "[]");
      const wishlist = JSON.parse(localStorage.getItem("wishlist") ?? "[]");
      if (cart.length === 0 && wishlist.length === 0) return;

      fetch("/api/account/sync-data", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cart, wishlist }),
      }).then(r => {
        if (r.ok) sessionStorage.setItem("data_synced_at", String(now));
      }).catch(() => {});
    } catch {}
  }, []);

  return null;
}
